import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './components/sidebar.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { sidebarReducer } from './store/sidebar.reducer';
import { RouterModule } from '@angular/router';
import { InstitutionSettingsModule } from '../institution-settings/institution-settings.module';

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule,
        TranslateModule.forChild(),
        StoreModule.forFeature('sidebar', sidebarReducer),
        RouterModule,
        InstitutionSettingsModule,
        SidebarComponent
    ],
    exports: [
        SidebarComponent
    ],
    providers: []
})
export class SidebarModule {
}
